import React, {
  forwardRef,
  useEffect,
  useRef,
  memo
} from 'react';

import Select from '../common/Select.jsx';

// backspace starts the editor on Windows
const KEY_BACKSPACE = 'Backspace';
// const KEY_ENTER = 'Enter';
// const KEY_TAB = 'Tab';

const MultiSelectCellEditor = memo(forwardRef(({column, value, onValueChange, eventKey, options, creatable, addCreatableOption, creatableOptions, isMulti = true, ...rest}, ref) => {
  const styles = {
    container: (provided, state) => ({
      ...provided,
      width: column.actualWidth,
      minHeight: 30,
      boxShadow: "inset 0px 0px 4px rgb(0 0 0 / 15%)",
    }),
    control: (provided, state) => ({
      ...provided,
      height: 40,
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "flex-start"
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: "#47a9a666",
      borderRadius: "3px",
      ":hover": {
        backgroundColor: "#47a9a6b3",
      },
      height: 30,
      alignItems: "center"
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: "#47a9a6b3",
      },
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      margin: 0,
      height: 40
    }),
    valueContainer: (provided, state) =>({
      ...provided,
      alignItems: "center",
      height:40,
      flexWrap: "nowrap"
    }),
    indicatorsContainer: (provided, state)=>({
      ...provided,
      height: 40
    })
  }

  const refContainer = useRef(null);

  const isLeftOrRight = (eventKey) => {
    return ['ArrowLeft', 'ArrowRight'].indexOf(eventKey) > -1;
  };

  const isCharNumeric = (charStr) => {
    return !!/\d/.test(charStr);
  };

  const isNumericKey = (eventKey) => {
    return isCharNumeric(eventKey);
  };

  const isBackspace = (eventKey) => {
    return eventKey === KEY_BACKSPACE;
  };

  // const finishedEditingPressed = (event) => {
  //   const key = event.key;
  //   return key === KEY_ENTER || key === KEY_TAB;
  // };

  // const onKeyDown = (event) => {
  //   if (isLeftOrRight(event) || isBackspace(event)) {
  //     event.stopPropagation();
  //     return;
  //   }

  //   if (!finishedEditingPressed(event) && !isNumericKey(event)) {
  //     if (event.preventDefault) event.preventDefault();
  //   }
  // };

  useEffect(() => {
    let startValue;

    if (isBackspace(eventKey) || isLeftOrRight(eventKey)) {
      startValue = '';
    } else {
      startValue = value;
    }

    if (startValue == null) {
      startValue = '';
    }

    if (!isNumericKey(eventKey)) {
      onValueChange(startValue);
    }

    refContainer.current.focus();
  }, []);

  return (
  <div ref={refContainer}>
    <Select 
      isMulti={isMulti}
      creatable={creatable} //TODO
      options={options ? options : []} 
      value={value} 
      onChange={(val) => onValueChange(val)}
      // onKeyDown={(event) => onKeyDown(event)}
      styles={styles} 
      creatableOptions={creatableOptions} //TODO
      addCreatableOption={addCreatableOption} //TODO
      closeMenuOnSelect = {false}
      autoFocus
      openMenuOnFocus
      {...rest}
    />
  </div>)
}));


export default MultiSelectCellEditor;